import { render, staticRenderFns } from "./CloudPlatform.vue?vue&type=template&id=e0461fee&scoped=true"
import script from "./CloudPlatform.vue?vue&type=script&lang=js"
export * from "./CloudPlatform.vue?vue&type=script&lang=js"
import style0 from "./CloudPlatform.vue?vue&type=style&index=0&id=e0461fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0461fee",
  null
  
)

export default component.exports